import { RouteRecordRaw } from 'vue-router';
import { HomologationPage, homologationRevisionStageGuard } from '@/pages/homologation';

export const routeName = 'Homologação';

export const route: RouteRecordRaw = {
  path: 'homologacao',
  name: routeName,
  component: HomologationPage,
  beforeEnter: homologationRevisionStageGuard,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Homologação',
    permissions: [
      { action: 'manageApproval', subject: 'Homologation' },
      { action: 'manageVerification', subject: 'Homologation' },
      { action: 'send', subject: 'Document' },
      { action: 'manage', subject: 'RecordManagement' },
    ],
    matchMode: 'any',
  },
};
